.Card {
  display: grid;
  position: relative;
  overflow: hidden;
  grid-auto-rows: max-content auto;
  border: var(--borderWidth-thin) solid var(--borderColor-default);
  box-shadow: var(--shadow-resting-small);
  background-color: var(--bgColor-default);
  gap: var(--stack-gap-normal);

  &[data-border-radius='large'] {
    border-radius: var(--borderRadius-large);
  }

  &[data-border-radius='medium'] {
    border-radius: var(--borderRadius-medium);
  }

  &[data-padding='normal'] {
    /* stylelint-disable-next-line primer/spacing */
    padding: var(--stack-padding-spacious);
  }

  &[data-padding='condensed'] {
    /* stylelint-disable-next-line primer/spacing */
    padding: var(--stack-padding-condensed);
  }

  &[data-padding='none'] {
    padding: 0;
  }

  &[data-layout='compact'] {
    display: flex;
    align-items: flex-start;
    gap: var(--stack-gap-condensed);
  }

  &[data-layout='compact'][data-padding='normal'] {
    /* stylelint-disable-next-line primer/spacing */
    padding: var(--stack-padding-normal);
  }
}

.CardHeader {
  display: block;
  width: 100%;
  height: auto;

  .Card:where([data-layout='compact']) & {
    flex: 0 0 auto;
    width: auto;
  }
}

.CardHeaderEdgeToEdge {
  /* stylelint-disable primer/spacing */
  margin-top: calc(-1 * var(--stack-padding-spacious));
  margin-right: calc(-1 * var(--stack-padding-spacious));
  margin-left: calc(-1 * var(--stack-padding-spacious));
  width: calc(100% + 2 * var(--stack-padding-spacious));
  /* stylelint-enable primer/spacing */
}

.CardImage {
  display: block;
  width: 100%;
  height: auto;
}

.CardIcon {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: var(--fgColor-muted);

  .Card:where([data-layout='default']) & {
    justify-content: center;
    width: var(--base-size-32);
    height: var(--base-size-32);
    border-radius: var(--borderRadius-medium);
    background-color: var(--bgColor-muted);
  }
}

.CardBody {
  display: grid;
  gap: var(--stack-gap-normal);

  .Card:where([data-layout='compact']) & {
    flex: 1 1 auto;
  }
}

.CardContent {
  display: grid;
  gap: var(--stack-gap-condensed);
}

.CardHeading {
  font: var(--text-title-shorthand-small);
  color: var(--fgColor-default);
  margin: 0;

  .Card:where([data-layout='compact']) & {
    position: relative;
    top: calc(-1 * var(--base-size-4));
    font-size: var(--text-body-size-medium);
  }
}

.CardDescription {
  font: var(--text-body-shorthand-medium);
  color: var(--fgColor-muted);
  margin: 0;
}

.CardMetadataContainer {
  display: flex;
  align-items: center;
  gap: var(--stack-gap-normal);
  font: var(--text-body-shorthand-medium);
  color: var(--fgColor-muted);
}

.CardMetadataItem {
  display: flex;
  align-items: center;
  gap: var(--stack-gap-condensed);
  font: var(--text-body-shorthand-small);
}

.CardAction {
  position: absolute;
  top: var(--base-size-16);
  right: var(--base-size-16);
  z-index: 1;
}
